export default "__VITE_ASSET__JEQtwvAA__"